import { Pipe, PipeTransform } from '@angular/core';
import { LocaleItem } from '../models/locale-data.model';


@Pipe({ 
  name: 'displayLocale' 
})
export class DisplayLocalePipe implements PipeTransform {
  
  transform<T extends LocaleItem>(
    items: T[], 
    defaultLocale: string | null,
    property: keyof T
  ): string {
    
    if (items.length === 0) {
      return '';
    }

    if (!defaultLocale) {
      return items[0][property] as string;
    }

    const defaultItem = items.find(item => item.locale === defaultLocale);
    
    return defaultItem ? 
      (defaultItem[property] as string) : 
      (items[0][property] as string);
  }
}